/* eslint-disable camelcase */
import React from 'react';
import { withTranslation } from 'config/i18n';
import { Typography, Button, Box } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { REQUIRED_STATUSES, VERIFIED_STATUSES, PAYEE_VERIFICATION_STATUS } from 'components/ownerPages/earningsAndPayouts/utils/constants';

const PayeeVerification = (props) => {
  const {
    t, payeeVerificationStatus, scriptLoaded, handleVerifyBtnClick, payoutMethodsCount,
  } = props;

  const theme = useTheme();

  const requiresVerification = (status) => {
    if (status == null) return true; // covers null and undefined
    return REQUIRED_STATUSES.includes(status);
  };
  const disableVerifiyBtn = () => !scriptLoaded
    || !payeeVerificationStatus
    || (requiresVerification(payeeVerificationStatus.identifier) && payoutMethodsCount === 0);

  const getStatusColor = (identifier) => {
    if (!identifier) return 'inherit';
    if (REQUIRED_STATUSES.includes(identifier)) return theme.palette.error.main;
    if (identifier === PAYEE_VERIFICATION_STATUS.FAILED) return theme.palette.error.main;
    if (identifier === PAYEE_VERIFICATION_STATUS.UNDER_REVIEW) return theme.palette.warning.dark; // dark yellow from theme
    if (VERIFIED_STATUSES.includes(identifier)) return theme.palette.success.main;
    return 'inherit';
  };

  const buildColoredStatusHtml = () => {
    const color = getStatusColor(payeeVerificationStatus?.identifier);
    const statusNameColored = `<span style="color: ${color}"><strong>${payeeVerificationStatus?.name || ''}</strong></span>`;
    const description = payeeVerificationStatus?.description ? ` - ${payeeVerificationStatus.description}` : '';
    return `${statusNameColored}${description}`;
  };

  return (
    <>
      <Typography variant="h3">
        {t('fe_earnings_and_payouts_page:payee_verification.title')}
      </Typography>
      <Box mb={2}>
        <Typography variant="h5">
          {t('fe_earnings_and_payouts_page:payee_verification.payee_verification_notice')}
        </Typography>
      </Box>

      {payeeVerificationStatus && (
        <Box mb={2}>
          <Typography
            variant="h5"
            component="div"
            dangerouslySetInnerHTML={{
              __html: t('fe_earnings_and_payouts_page:payee_verification.verification_status', {
                verification_status: buildColoredStatusHtml(),
                interpolation: { escapeValue: false },
              }),
            }}
          />
        </Box>
      )}

      {requiresVerification(payeeVerificationStatus?.identifier) && (
        <>
          <Box mb={2}>
            <Typography variant="h5">
              {t('fe_earnings_and_payouts_page:payee_verification.verification_requirements_info')}
            </Typography>
          </Box>

          <Box mb={2}>
            <Typography
              variant="h5"
              component="div"
              dangerouslySetInnerHTML={{
                __html: t(
                  'fe_earnings_and_payouts_page:payee_verification.add_payout_method_message',
                ),
              }}
            />
          </Box>
          <Button
            variant="contained"
            color="secondary"
            disabled={disableVerifiyBtn()}
            onClick={handleVerifyBtnClick}
          >
            {t('fe_earnings_and_payouts_page:payee_verification.verifiy_now')}
          </Button>
          {/* Widget container */}
          <div id="VerificationUI" />
        </>
      )}
    </>
  );
};

export default withTranslation(['fe_earnings_and_payouts_page'])(PayeeVerification);
